import React, { useMemo } from 'react';
import { Text, View } from 'react-native';
import { useTheme } from '../../../hooks/useTheme';
import { makeStyles } from './ActionLogs.styles';

interface Props {
  errors: number;
  warnings: number;
  info: number;
  date?: string;
}

const ActionLogsSummary: React.FC<Props> = ({
  errors,
  warnings,
  info,
  date,
}) => {
  const { colors } = useTheme();
  const styles = useMemo(() => makeStyles(colors), [colors]);

  const summary = [
    { count: errors, label: 'Errors', color: colors.negative },
    { count: warnings, label: 'Warnings', color: colors.focus },
    { count: info, label: 'Info', color: colors.neutral },
  ];

  return (
    <View style={styles.summary}>
      <View style={styles.summaryRow}>
        {summary.map(item => (
          <View style={styles.summaryItem} key={item.label}>
            <View style={[styles.squircle, { backgroundColor: item.color }]} />
            <Text style={styles.summaryLabel}>
              <Text style={styles.summaryCount}>{item.count} </Text>
              {item.label}
            </Text>
          </View>
        ))}
      </View>
      {!!date && <Text style={styles.summaryDate}>Date: {date}</Text>}
    </View>
  );
};

export default ActionLogsSummary;
